import Table from "react-bootstrap/Table";

const MainScreen = () => {
	return <div className="device-list component-wrapper">
    
  </div>;
};

export default MainScreen;
